import { SelectableTable } from '@openx/components-table/SelectableTable/SelectableTable.tsx';
import { Table, TableName } from '@openx/components-table/Table.tsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getDealsProposedSensitiveCategoriesColumns } from '../constants.tsx';
import type { DealAdCategoryProposal } from '../model.ts';
import type { ShareDealsSensitiveCategoriesListProps } from '../types.ts';

const DealsSensitiveCategoriesSelectableTable = <T extends Partial<DealAdCategoryProposal>>() =>
  SelectableTable<T>(Table);

export function DealProposedSensitiveCategoriesList({
  items,
  criteria,
  selectedItems,
  rowActions,
  onCriteriaChange,
  onSelectChange,
}: ShareDealsSensitiveCategoriesListProps) {
  const Table = DealsSensitiveCategoriesSelectableTable<DealAdCategoryProposal>();
  const { t } = useTranslation();
  const [primaryAction, dangerAction] = rowActions;
  const columns = useMemo(() => getDealsProposedSensitiveCategoriesColumns(t), [t]);

  return (
    <Table
      loading={false}
      name={TableName.DEALS_SENSITIVE_CATEGORIES_PROPOSED}
      data={items}
      columns={columns}
      selectedItems={selectedItems}
      toggleSelect={onSelectChange}
      criteria={criteria}
      onCriteriaChange={onCriteriaChange}
      primaryRowAction={primaryAction}
      dangerRowAction={dangerAction}
    />
  );
}
